<template>
  <v-card >
    <v-card-text>
      <v-container fluid>
        <v-row dense>  
          <v-col cols="12" xl="9">
            <v-simple-table dense class="mt-1">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" width="3%">LIV.</th>
                    <th class="text-left" width="3%">TIPO</th>
                    <th class="text-left" width="15%">CODICE</th>
                    <th class="text-left" width="25%">DESCRIZIONE</th>
                    <th class="text-left" width="16%">LOTTO</th>
                    <th class="text-left" width="4%">UM</th>
                    <th class="text-right" width="15%">VALORE TEORICO</th>
                    <th class="text-right" width="15%">VALORE UTILIZZATO</th>
                    <th class="text-right" width="4%"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in distinta" :key="index" :class="{ semilavorato: item.semilavorato, manuale: item.manuale }" @click="onClickRow(item, $event)">
                    <td class="text-left pl-2">{{ item.livello }}</td>
                    <td class="text-left"><v-icon :title="titoloIcona(item)">{{ icona(item) }}</v-icon></td>
                    <td class="text-left" v-if="item.tipo !== 'nota'">{{ item.codice }}</td>
                    <td class="text-left" v-if="item.tipo !== 'nota'">{{ item.descrizione }}</td>
                    <td class="text-left" v-else colspan="2">{{ item.descrizione }}</td>
                    <td class="text-left" v-if="item.richiedeLotto">{{ item.lotto }}</td>
                    <td class="text-left" v-else-if="item.tipo === 'prodotto' && !item.semilavorato">- - -</td>
                    <td v-else></td>
                    <td class="text-left">{{ item.unitaMisura }}</td>
                    <td class="text-right">{{ item.valore || item.quantita || '' }}</td>
                    <td class="text-right pr-3" v-if="usaQuantitaTeorica || item.semilavorato || item.tipo === 'nota'">
                      {{ item.valoreUsato || item.usato || '' }}
                    </td>
                    <td class="text-right pr-3" v-else-if="item.tipo === 'prodotto'" :class="{ 'usato-diverso-quantita': (item.quantita !== item.usato) }">
                      <v-text-field v-model="item.usato" data-campo="usato" dense flat solo hide-details="auto" :readonly="item.semilavorato" :placeholder="String(item.quantita)" :rules="[numerico]" reverse :background-color="'transparent'" @change="onChangeUsato(item, true)"/>
                    </td>
                    <td class="text-right pr-3" v-else-if="item.tipo === 'multiselect'">
                      <v-select v-model="item.valoreUsato" dense flat solo hide-details="auto" :items="item.valori" item-text="valore" item.value="valore" @change="onChangeUsato(item)" reverse></v-select>
                    </td>
                    <td class="text-right pr-3" v-else>
                      <v-text-field v-model="item.valoreUsato" dense flat solo hide-details="auto" :readonly="item.semilavorato" :placeholder="String(item.valore || '')" reverse @change="onChangeUsato(item)"/>
                    </td>
                    <td class="text-right"><v-btn v-if="item.semilavorato && aggiuntaProdottoAbilitata" icon @click.stop="onNuovoProdotto(item, index)" title="Aggiungi un prodotto"><v-icon>mdi-plus-circle-outline</v-icon></v-btn></td>
                  </tr>
                </tbody>                
              </template>
            </v-simple-table>
          </v-col>
          <v-col cols="12" xl="3">
            <v-row class="mt-7">
              <v-col>
                <v-text-field v-model="quantitaProdotta" dense class="ml-5 mr-5 text-h6" hide-details="auto" placeholder="Quantità prodotta" :rules="[numerico]" reverse :background-color="'transparent'" @change="onChangeQtaProdotta"/>
              </v-col>
              <v-col>
                <v-switch v-model="usaQuantitaTeorica" inset class="ml-2 mt-0" dense hide-details="auto" label="Usa quantità teorica"/>
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
            <v-row><v-col v-if="nonSufficiente" class="red--text font-weight-medium">ATTENZIONE! Le quantità disponibili nel magazzino temporaneo non sono sufficienti per la produzione impostata</v-col></v-row>
            <v-row class="mt-7">
              <v-spacer></v-spacer>
              <v-col>
                <v-btn @click.stop="confermaProduzione" :disabled="!quantitaProdotta || nonSufficiente" title="Vengono generati i movimenti di produzione">Conferma Produzione</v-btn>
              </v-col>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-dialog v-model="dialogProdotto" max-width="700px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Inserimento prodotto</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="9">
                    <component :is="'pProdotto'" :item="itemCodice(editedItem)" :index="0" @change="componentValueChange" :updateTrigger="trigger" :solo="false" :suTable="true" :isLotto="true" :isProdottoBase="true" :clearInfo="clearInfo" :popolaInfo="popolaInfo"/>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <v-text-field v-model="editedItem.quantita" label="Quantità Teorica" flat dense :rules="[numerico]" @change="onChangeQuantita" reverse></v-text-field>
                  </v-col>                  
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.descrizione" label="Descrizione"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <!-- <component :is="'pLotto'" :item="itemLotto(item)" :index="0" @change="componentValueChange" :updateTrigger="trigger" :codiceProdotto="editedItem.codice" :solo="false" :suTable="true" :clearInfo="clearInfo"/> -->
                    <v-autocomplete
                      v-model="editedItem.lotto"
                      :items="lottiProdotto"
                      label="Lotti prodotto"
                      item-text="testo"
                      item-value="id"
                      clearable
                      dense
                      hide-details="auto"
                      :flat="true"
                      :return-object="true"
                    >
                      <template v-slot:selection="{ item }">
                        <span>{{ item.testo }}</span>
                      </template>  
                    </v-autocomplete>
                  </v-col>                  
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDialogProdotto">Annulla</v-btn>
              <v-btn color="blue darken-1" text @click="saveDialogProdotto">Salva</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>  
        <v-dialog v-model="dialogLotto" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Inserimento lotto per prodotto</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>             
                  <v-col cols="12" sm="12" md="12">
                    <!-- Elenco dei lotti: filtro per Codice === _id prodotto base e !lotti.ProdottoBase -->
                    <!-- <component :is="'pLotto'" :item="itemLotto(item)" :index="0" @change="componentValueChange" :updateTrigger="trigger" :codiceProdotto="editedItem.codice" :solo="false" :suTable="true" :clearInfo="clearInfo"/> -->
                    <v-autocomplete
                      v-model="editedItem.lotto"
                      :items="lottiProdotto"
                      label="Lotti prodotto"
                      item-text="testo"
                      item-value="id"
                      clearable
                      dense
                      hide-details="auto"
                      :flat="true"
                      :return-object="true"
                    >
                      <template v-slot:selection="{ item }">
                        <span>{{ item.testo }}</span>
                      </template>                    
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDialogLotto">Annulla</v-btn>
              <v-btn color="blue darken-1" text @click="saveDialogLotto">Salva</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>              
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
  import * as dot from 'dot-object'
  import _ from 'lodash'
  import { ordinaLotti } from '@/components/helpers'
  import prodotti from '@/services/prodottiService.js'
  import movimenti from '@/services/movimentiService.js'
  import magazzino from '@/services/magazzinoService.js'
  import documenti from '@/services/documentiService.js'
  import configurazioni from '@/services/configurazioniService.js'
  import pProdotto from '../../elementi/prodotto'

  export default {
    components: {
      pProdotto
    },
    props: {
      locLotto: Object,
      item: Object,
      // usaQuantitaTeorica: { type: Boolean, default: true },
      updateTrigger: Number,
      magazziniTemporanei: Array
    },
    data () {
      return {
        // usaQtaTeorica: true,
        distinta: [],
        numerico: value => !isNaN(value) || 'Il valore deve essere numerico',
        aggiuntaProdottoAbilitata: true, // TODO: Passare da impostazioni
        dialogLotto: false,
        dialogProdotto: false,
        editedIndex: -1,
        editedItem: {
          tipo: 'prodotto',
          codice : '',
          descrizione: '',
          lotto: '',
          unitaMisura: '',
          quantita: 1,
          livello: 0
        },
        defaultItem: {
          tipo: 'prodotto',
          codice : '',
          descrizione: '',
          lotto: '',
          unitaMisura: '',
          quantita: 1,
          livello: 0
        },
        trigger: 1,
        clearInfo: 1,
        popolaInfo: 1,
        lottiProdotto: [],
        quantitaProdotta: '',
        usaQuantitaTeorica: true,
        magazzino: null,
        nonSufficiente: false
      }
    },
    async mounted() {
      if (this.item) {
        const confMagazzini = await configurazioni.getConfigurazione('magazzini_temporanei')
        this.magazzino = confMagazzini.magazzini.find(x => x.codice === this.locLotto.magazzinoTemporaneo)   
        await this.caricaDistinta(parseFloat(this.quantitaProdotta))
      }
    },
    watch: {
      async item(value) {
        await this.elaboraDistinta(value.quantita)
      },
      async updateTrigger() {
        await this.elaboraDistinta(this.item.quantita)
      },
      async usaQuantitaTeorica(value) {
        if (value) {
          // await this.caricaDistinta(this.item.quantita)
          await this.caricaDistinta(parseFloat(this.quantitaProdotta))
        }
      },      
      distinta(value) {
        if (value) {
          console.log('change distinta')
          this.$emit('distinta', value)
        }
      }
    },
    methods: {
      async onChangeQtaProdotta() {
        await this.caricaDistinta(parseFloat(this.quantitaProdotta))
        this.verificaQuantitaSufficienti()
      },
      verificaQuantitaSufficienti() {
        let nonSufficiente = false
        const disponibili = this.magazzino.prodotti
        for (let p of this.distinta.filter(x => x.tipo === 'prodotto' && !x.semilavorato)) {
          const suTemp = disponibili.find(x => x.id === p.codiceProdotto || (!x.id && x.codice === p.codice))
          if (suTemp) {
            if (suTemp.residuo < p.quantita) {
              nonSufficiente = true
            }
          }
        }
        this.nonSufficiente = nonSufficiente
      },
      async confermaProduzione() {
        let item = this.item

        const distintaAttuale = JSON.parse(JSON.stringify(item.distinta))
        // Teoricamente dovrebbe essere sempre uguale, ma potrei cambiarla
        const distintaModificata = distintaAttuale.some(x => x.manuale || (x.tipo === "prodotto" && x.quantita !== x.usato) || (x.tipo === "parametro" && x.valore !== x.valoreUsato))
        item.produzione = item.produzione || []
        let prodotto_lotto = ''
        let riga = this.locLotto.righe.indexOf(this.item)
        if (item.produzione.length === 0) {
          prodotto_lotto = await this.creaProdottoLotto(item.prodotto.codice, riga, distintaAttuale)
          await prodotti.clearCache()
        } else {
          prodotto_lotto = await prodotti.getProdotto(item.produzione[0].codice)
        }
        item.produzione.push({
          base: prodotto_lotto.codice,
          codice: prodotto_lotto._id,
          lotto: this.locLotto.codice,
          distintaModificata,
          distinta: distintaAttuale,
          unitaMisura: prodotto_lotto.magazzino.unitaMisura,
          quantita: this.quantitaProdotta,
          data: new Date()
        })
        await this.verificaAggiungiMovimenti(this.locLotto, prodotto_lotto, this.quantitaProdotta, distintaAttuale)
        this.$emit('documento', this.locLotto)
        await this.$nextTick()
        this.quantitaProdotta = ''

        // TODO
        // Mostrare messaggio ok caricato
        // aggiornare la giacenza nel magazzino temporaneo
      },
      async creaProdottoLotto(base, prog, distinta) {
        // const base = p.prodotto.codice
        const prodottoBase = await prodotti.getProdotto(base)
        const lotto = this.locLotto
        let pr = {...prodottoBase}
        delete pr._rev
        delete pr.valore
        delete pr.appoggio
        delete pr.prodotto
        pr.barcode = []
        pr.descrizione = `${pr.descrizione.trim()}-L.${lotto.codice}.${prog}`
        pr.ultimoAcquisto = {} // completare
        pr.lotti.prodottoBase = false
        pr.lotti.base = base
        pr.lotti.lotto = lotto.codice
        pr.lotti.progressivo = prog
        pr.lotti.produzione = lotto.produzione
        pr.lotti.scadenza = lotto.scadenza
        pr.lotti.distinta = distinta
        pr._id = `${base}.${lotto.codice}.${prog}`
        pr.codice = base  // (il codice rimane lo stesso del prodotto base)
        pr.magazzino.giacenza = 0
        pr.magazzino.giacenzaParziale = null
        pr.magazzino.valore = 0
        await prodotti.creaProdotto(pr)
        return pr
      },
      async verificaAggiungiMovimenti(documento, prodotto, quantita, distintaAttuale) {
        // Percorre la distinta e crea tutti i movimenti relativi ai prodotti non di appoggio
        // const prodottiDocumento = documento.righe.filter(x => x.prodotto && x.prodotto.codice)
        const modello = await movimenti.getModello('lotto')
        let numErrori = 0
        let p = prodotto
      //  for (const p of prodottiDocumento) {
        // ********************************************************************
        // Carico Item Prodotto
        // ********************************************************************
          let movimento = JSON.parse(JSON.stringify(modello))
          movimento.data = new Date()
          movimento.magazzino = documento.magazzino
          movimento.prodotto = {
            codice: p._id,
            lotti: [],
            um: p.unitaMisura,
            quantita: +parseFloat(quantita).toFixed(2),
            prezzoAcquisto: _.get(p, 'appoggio.prodotto.acquisto', 0),
            prezzoUnitario: _.get(p, 'valore.listino.ivato', true) ? _.get(p, 'valore.prezzoUnitario', 0) : _.get(p, 'valore.prezzoNettoUnitario', 0),
            listino: _.get(p, 'valore.listino', null)
          }
          movimento.quantita = +parseFloat(quantita).toFixed(2)
          movimento.valore = p.valore ? +parseFloat(p.valore.importoTotale || 0).toFixed(2) : 0
          movimento.causale = documento.tipoDocumento.causale
          movimento.anagrafica = {
            cliente: _.get(documento, 'anagrafica.cliente', ''),
            fornitore: ''
          }
          movimento.riferimento = {
            tipo: 'documento',
            id: documento.codice,
            data: documento.data
          }
          if (!await magazzino.creaMovimenti(movimento)) {
            numErrori++
          }
        // ********************************************************************
        // Scarico i componenti secondo la distinta base
        // ********************************************************************
        const distinta = distintaAttuale || []
        for (let el of distinta) {
          if (el.tipo === 'prodotto' && !el.semilavorato) {
            let magPrelievo = documento.magazzino
            const mt = this.magazziniTemporanei.find(x => x.codice === documento.magazzinoTemporaneo)
            if (mt.prodotti.find(x => x.id === el.codiceProdotto || (!x.id && x.codice === el.codiceProdotto))) {
              // Anche se non è gestito a lotti, se è presente nel temporaneo lo prendo da li
              magPrelievo = documento.magazzinoTemporaneo
            }
            let movimento = JSON.parse(JSON.stringify(modello))
            movimento.data = new Date()
            movimento.magazzino = magPrelievo
            movimento.prodotto = {
              codice: el.codiceProdotto,
              lotto: el.lotto,
              lotti: [],
              um: el.unitaMisura,
              quantita: +parseFloat(el.quantita).toFixed(2)
              // TODO: Calcolare se serve ...

              // prezzoAcquisto: _.get(p, 'appoggio.prodotto.acquisto', 0),
              // prezzoUnitario: _.get(p, 'valore.listino.ivato', true) ? _.get(p, 'valore.prezzoUnitario', 0) : _.get(p, 'valore.prezzoNettoUnitario', 0),
              // listino: _.get(p, 'valore.listino', null)
            }
            movimento.quantita = +parseFloat(el.quantita).toFixed(2)
            // movimento.valore = el.valore ? +parseFloat(el.valore.importoTotale).toFixed(2) : 0
            movimento.causale = documento.tipoDocumento.causale2
            movimento.anagrafica = {
              cliente: _.get(documento, 'anagrafica.cliente', ''),
              fornitore: ''
            }
            movimento.riferimento = {
              tipo: 'documento',
              id: documento.codice,
              data: documento.data,
              note: 'scarico distinta'
            }
            console.log('movimento', movimento)
            if (!await magazzino.creaMovimenti(movimento)) {
              numErrori++
            }
          }
        }
      },  
      infoLotto(item) {
        return `${item.testo} - sc:${item.scadenza} - qta:${item.giacenza}`
      },
      icona(item) {
        switch(item.tipo) {
          case 'nota':
            return 'mdi-note-outline'
          case 'parametro':
            return 'mdi-cog-outline'
          case 'multiselect':
            return 'mdi-selection-multiple'
          default:
            if (item.manuale) {
              return 'mdi-hand-back-left-outline'
            }
            return ''
        }
      },
      titoloIcona(item) {
        switch(item.tipo) {
          case 'nota':
            return 'Nota'
          case 'parametro':
            return 'Parametro'
          case 'multiselect':
            return 'Selezione multipla'
          default:
            if (item.manuale) {
              return 'Inserimento manuale'
            }
            return ''
        }
      },
      onClickRow(item, event) {
        if (event.target.attributes['data-campo']) {
          return
        }
        if (item.manuale) {
          this.onEditProdotto(item)
        }
      },
      onEditProdotto(item) {
        if (item.manuale) {
          this.editItemProdotto(item)
        }
      },
      editItemProdotto (item) {
        this.editedIndex = this.distinta.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.popolaInfo++
        this.dialogProdotto = true
      },
      closeDialogProdotto() {
        this.dialogProdotto = false
        this.$nextTick(() => {
          this.clearInfo++
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },      
      saveDialogProdotto() {
        if (this.editedIndex > -1) {
          Object.assign(this.distinta[this.editedIndex], this.editedItem)
        } else {
          this.distinta.push(this.editedItem)
        }
        this.closeDialogProdotto()
      },
      async onEditLotto(item) {
        if (item.tipo === 'prodotto' && !item.semilavorato) {
          await this.popolaLottiProdotto(item.codice)
          this.editItemLotto(item)
        }
      },
      editItemLotto (item) {
        this.editedIndex = this.distinta.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogLotto = true
      },      
      closeDialogLotto() {
        this.dialogLotto = false
        this.$nextTick(() => {
          this.clearInfo++
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      saveDialogLotto() {
        if (this.editedIndex > -1) {
          Object.assign(this.distinta[this.editedIndex], this.editedItem)
        } else {
          this.distinta.push(this.editedItem)
        }
        this.closeDialogLotto()
      },
      async onNuovoProdotto(item, index) {
        let newItem = JSON.parse(JSON.stringify(this.defaultItem))
        newItem.livello = item.livello + 1
        newItem.quantita = ''
        newItem.usato = 0
        newItem.manuale = true
        newItem.tipo = 'prodotto'
        //const insertionPosition = index + 2
        let el = this.distinta.indexOf(item)
        
        let childs = 0
        while (++el < this.distinta.length) {
          const dd = this.distinta[el]
          if (!dd.semilavorato) {
            childs++
          } else {
            break
          }
        }
        
        const insertionPosition = index + childs + 1
        const list1 = this.distinta.splice(0, insertionPosition)
        const list2 = this.distinta
        this.distinta = [...list1, newItem, ...list2]
      },
      onChangeQuantita() {
        this.editedItem.quantita = +parseFloat(this.editedItem.quantita).toFixed(2)
        this.editedItem.usato = this.editedItem.quantita 
      },
      onChangeQtaTeorica() {
        for (let el of this.distinta) {
          el.usato = el.quantita
        }
        this.$emit('distinta', this.distinta)
      },
      onChangeUsato(item, isQuantita) {
        if (isQuantita) {
          item.usato = parseFloat(item.usato || 0)
        }
        // console.log('change usato')
        this.$emit('distinta', this.distinta)
      },
      async elaboraDistinta(qta) {
        // legge in base al prodotto selezionato
/*         const distinta = require('./distinta.json')
        const elenco = this.elaboraItem(distinta, qta, 0)
        this.distinta = elenco */
      },
      async caricaDistinta(qta) {
        // legge in base al prodotto selezionato
        // const distinta = require('./distinta.json')
        const prodotto = await prodotti.getProdotto(this.item.prodotto.codice)
        const itmDistinta = _.get(prodotto, 'bom.gestione.distinta')
        if (itmDistinta) {
          const codice = itmDistinta.codice
          const doc = await documenti.getDocumento(codice)
          const distinta = doc.distinta
          const elenco = this.elaboraItem(distinta, qta, 0)
          this.distinta = elenco
        } else {
          this.distinta = []
        }
      },
      elaboraItem(item, qta = 1, livello) {
        let elenco = []
        if (item.items) {
          elenco.push({ livello: livello, tipo:item.tipo || 'prodotto', richiedeLotto: item.richiedeLotto, codice: item.codice, descrizione: item.descrizione, quantita: !isNaN(qta * item.quantita) ? +(qta * item.quantita).toFixed(2) : '', valore: item.valore, lotto: '---', semilavorato: true, usato: !isNaN(qta * item.quantita) ? +(qta * item.quantita).toFixed(2) : '', unitaMisura: item.unitaMisura })
          for (let i of item.items) {
            const totQta = qta * item.quantita
            elenco = elenco.concat(this.elaboraItem(i, totQta, livello + 1))
          }
        } else {
          let valori = item.valori || []
          if (item.codice) {
            const prodotto = this.magazzino.prodotti.find(x => x.codice === item.codice)
            if (prodotto) {
              item.lotto = prodotto.lotto || ''
              item.codiceProdotto = prodotto.id || prodotto.codice
            }
          }
          switch (item.tipo) {
            case 'multiselect':
              item.valore = item.valori.length > 0 ? item.valori[0]: 0
            break
            default:
            break
          }
          elenco.push({ livello, tipo:item.tipo || 'prodotto', richiedeLotto: item.richiedeLotto, codice: item.codice, descrizione: item.descrizione, quantita: !isNaN(qta * item.quantita) ? +(qta * item.quantita).toFixed(2) : '', valore: item.valore || '', valoreUsato: item.valore || '', lotto: item.lotto, codiceProdotto: item.codiceProdotto,  semilavorato: false, usato: !isNaN(qta * item.quantita) ? +(qta * item.quantita).toFixed(2) : '', unitaMisura: item.unitaMisura, valori: valori })
        }
        return elenco
      },
      itemCodice(item) {
        // console.log('itemcodice', item.codice)
        return {
          "model": "codice",
          "valueField": "codice",
          "label": "Codice Prodotto",
          "type": "Prodotto",
          "required": false,
          "hint": "descrizione",
          "readOnly": true,
          "addForbidden": true,
          value: (item && item.codice) || ''
        }
      },
      itemLotto(item) {
        return {
          "model": "lotto",
          "valueField": "lotto",
          "label": "Lotto Prodotto",
          "type": "Lotto",
          "required": false,
          "hint": "descrizione",
          "readOnly": true,
          "addForbidden": true,
          value: (item && item.lotto) || ''
        }
      },
      async componentValueChange(data) {
        // console.log('componentValueChange', data.model)
        const { model, subModel, value, decimals, index } = data
        let tgt = {}
        if (subModel) {
          let vv = value[subModel]
          if (decimals >= 0) {s
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        } else {
          let vv = value
          if (decimals >= 0) {
            vv = +parseFloat(vv).toFixed(decimals)
          }
          dot.str(model, vv, tgt)
        }
        _.merge(this.editedItem, tgt)
        await this.aggiornaCorrelati(data)
      },
      async aggiornaCorrelati(data) {
        switch (data.model) {
          case 'codice':
            this.editedItem.descrizione = _.get(data, 'item.descrizione', '')
            this.editedItem.unitaMisura = _.get(data, 'item.item.magazzino.unitaMisura', '')
            this.trigger++
            await this.popolaLottiProdotto(data.value)
            // this.elaboraDistinta()
            break
          default:
            break
        }
      },
      changeQuantita(value) {
        const qta = parseFloat(value)
        this.elaboraDistinta(qta)
      },
      async popolaLottiProdotto(codiceProdotto, quantita) {
        const filtri = {
          codice: codiceProdotto,
          isLotto: true,
          isLottoBase: false
        }
        const opzioni =  {
          itemsPerPage: -1
        }
        const data = await prodotti.getFilteredProducts(filtri, opzioni)
        const cp = data && data.total_rows > 0 ? data.rows.map(x => x.doc) : []
        //TODO: I lotti vanno ordinati seocndo la gestione che è stata impostata (FIFO, FEFO, etc.)
        const gestione = _.get(this.item,'appoggio.prodotto.item.lotti.gestione.criterioConsumoScarico.codice', '')
        this.lottiProdotto = ordinaLotti(cp, gestione, quantita).map(x => {
          return {
            id: x.lotti.lotto,
            testo: x.lotti.lotto,
            testo: `${x.lotti.lotto} - sc:${x.lotti.scadenza || '---'} - qta:${x.magazzino.giacenza}`,
            codiceProdotto: x._id,
            giacenza: x.magazzino.giacenza, // TODO: Verificare per giacenza multipla
            scadenza: x.lotti.scadenza || '---' // TODO: Più eventuali altre date
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .v-input {
    font-size: 14px;
  }
  .semilavorato {
    background-color: rgb(222, 228, 233);
  }
  .manuale {
    background-color: rgb(193, 241, 183);
  }
  .usato-diverso-quantita {
    color: '#EF5350';
  }
</style>
